import {
	avatarSrc as absoluteAvatarSrc,
	createApiClient,
	uploadFile as clientUploadFile,
	type UploadParams,
	type UploadPath,
} from '@shared/api-client/index';

// The api origin (no version): each operation path carries its own /v1 prefix.
export const apiOrigin = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export const api = createApiClient(apiOrigin);

// Resolve a DTO `avatarUrl` to an absolute `<img>` src on this app's api origin.
export const avatarSrc = (avatarUrl: string | null | undefined) =>
	absoluteAvatarSrc(apiOrigin, avatarUrl);

/** POST a single `file` as multipart/form-data, bound to this app's client. */
export function uploadFile<P extends UploadPath>(path: P, params: UploadParams<P>, file: File) {
	return clientUploadFile(api, path, params, file);
}
